import React from 'react'
import { CSSTransition } from 'react-transition-group'
import styles from './index.module.scss'
import logo from './logo.png'
import logoStar from './logo-star.png'
import { $t } from '@/i18n/intl'

interface EntryLogoProps {
  /** 是否显示 logo */
  /** 自定义样式类名 */
  className?: string
  /** 可见状态变化回调 */
  onVisibleChange?: (visible: boolean) => void
}

const fadeInTime = 600
const showTime = 800

const EntryLogo: React.FC<EntryLogoProps> = ({ className = '', onVisibleChange = () => {} }) => {
  const [isVisible, setIsVisible] = React.useState(true)

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false)
    }, fadeInTime + showTime)
    return () => clearTimeout(timer)
  }, [])

  // 处理动画状态变化回调
  const handleEntered = () => {
    onVisibleChange(true)
  }

  const handleExited = () => {
    onVisibleChange(false)
  }

  const containerClass = [styles.logoContainer, className || ''].filter(Boolean).join(' ')

  return (
    <CSSTransition
      unmountOnExit
      in={isVisible}
      appear
      timeout={fadeInTime}
      classNames={{
        enter: styles.fadeEnter,
        enterActive: styles.fadeEnterActive,
        exit: styles.fadeExit,
        exitActive: styles.fadeExitActive,
        appear: styles.fadeEnter,
        appearActive: styles.fadeEnterActive
      }}
      onEntered={handleEntered}
      onExited={handleExited}
    >
      <div className={containerClass}>
        <div className={styles.logoWrapper}>
          <img src={logo} alt="logo" className={styles.logo} />
          {/* 星星旋转动画 */}
          <CSSTransition
            in={isVisible}
            appear
            timeout={fadeInTime}
            classNames={{
              enter: styles.starRotateEnter,
              enterActive: styles.starRotateEnterActive,
              exit: styles.starRotateExit,
              exitActive: styles.starRotateExitActive,
              appear: styles.starRotateEnter,
              appearActive: styles.starRotateEnterActive
            }}
          >
            <img src={logoStar} alt="logo-star" className={styles.logoStar} />
          </CSSTransition>
        </div>
        <div className={styles.welcomeText}>{$t('demo.main.logoText')}</div>
      </div>
    </CSSTransition>
  )
}

export default EntryLogo
